import { Flex, Text } from '@chakra-ui/react';

import { useParams } from 'react-router-dom';

import { RewardAndRecognitionTab } from 'app/components/Settings/RewardAndRecognitionTab';
import AuthenticatedPageWrapper from 'app/components/UI/AuthenticatedPageWrapper';

function Settings() {
  const { companyId } = useParams();

  return (
    <AuthenticatedPageWrapper title="Reward & Recognition Settings">
      <Flex flexDir="column" gap="20px" h="full">
        <Flex flexDir="column" gap="8px">
          <Text as="h2" textStyle="h2" color="brand.darkPurple">
            Settings
          </Text>
          <Text color="brand.darkPurple">
            Configure reward &amp; recognition behaviour for this company
          </Text>
        </Flex>

        <RewardAndRecognitionTab companyId={companyId} />
      </Flex>
    </AuthenticatedPageWrapper>
  );
}

export default Settings;
